// @flow
import * as React from 'react';

import UserSchoolsContainer from './UserSchoolsContainer';
import UserSchoolsForm from './UserSchoolsForm';

class UserSchools extends React.Component<*, *> {
  render() {
    return <UserSchoolsContainer>{props => <UserSchoolsForm {...props} />}</UserSchoolsContainer>;
  }
}

export default UserSchools;
